import { useEffect, useState } from 'react';
import ApexChart from 'react-apexcharts';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { colors, fontWeight, Heading, Icons, Menu, Text, textLevel } from '../../../../../packages';
import { chartOptions } from '../../../data-collection-template-detail/components/assignments-chart-card/AssignmentsCard.utils';
import { AppointmentsFilterDates } from '../../../../../constants/CommonConstants';
import { useStyles } from './AssignmentsChartCard.styles';

const AssignmentsChartCard = ({ profileElementDetailByMonth, isLoading }) => {
  const classes = useStyles();
  const [chartDates, setChartDates] = useState([]);
  const [chartSeriess, setChartSeriess] = useState([]);
  const [selectedTime, setSelectedTime] = useState(AppointmentsFilterDates[2]);
  // const [selectedStatus, setSelectedStatus] = useState(AppointmentsFilterStatus[0]);
  const chartSeries = [];
  const chartDays = [];

  let filtered = [];
  const currentDate = dayjs();

  switch (selectedTime.value) {
    case 7:
      filtered = profileElementDetailByMonth.filter(item => {
        const sevenDaysAgo = currentDate.subtract(7, 'day');
        return dayjs(item.date, 'DD-MM-YYYY').isAfter(sevenDaysAgo);
      });

      break;
    case 30:
      filtered = profileElementDetailByMonth.filter(item => {
        const thirtyDaysAgo = currentDate.subtract(30, 'day');
        return dayjs(item.date, 'DD-MM-YYYY').isAfter(thirtyDaysAgo);
      });

      break;
    case 90:
      filtered = profileElementDetailByMonth.filter(item => {
        const ninetyDaysAgo = currentDate.subtract(90, 'day');
        return dayjs(item.date, 'DD-MM-YYYY').isAfter(ninetyDaysAgo);
      });

      break;
    case 180:
      filtered = profileElementDetailByMonth.filter(item => {
        const oneEightyDaysAgo = currentDate.subtract(180, 'day');
        return dayjs(item.date, 'DD-MM-YYYY').isAfter(oneEightyDaysAgo);
      });

      break;
    case 360:
      filtered = profileElementDetailByMonth.filter(item => {
        const threeSixtyDaysAgo = currentDate.subtract(360, 'day');
        return dayjs(item.date, 'DD-MM-YYYY').isAfter(threeSixtyDaysAgo);
      });

      break;
    default:
      filtered = profileElementDetailByMonth.filter(item => {
        const thirtyDaysAgo = currentDate.subtract(30, 'day');
        return dayjs(item.date, 'DD-MM-YYYY').isAfter(thirtyDaysAgo);
      });
  }

  const compareDates = (obj1, obj2) => {
    const date1 = dayjs(obj1.date, 'DD-MM-YYYY');
    const date2 = dayjs(obj2.date, 'DD-MM-YYYY');
    return date1.diff(date2);
  };

  // Sort the array of date strings
  const sortedDates = filtered.sort(compareDates);

  sortedDates.forEach(item => {
    chartSeries.push(item.count);
    chartDays.push(item.date);
  });

  const times = AppointmentsFilterDates.map(time => ({
    ...time,
    onClick: () => setSelectedTime(time),
  }));

  const hasAssignments = () => {
    return profileElementDetailByMonth?.length > 0;
  };

  const hasDataInRange = () => {
    return filtered?.length > 0;
  };

  useEffect(() => {
    setChartSeriess(chartSeries);
    setChartDates(chartDays);
  }, [selectedTime]);

  // const statuses = [AppointmentsFilterStatus[0]].map(status => ({
  //   ...status,
  //   onClick: () => setSelectedStatus(status),
  // }));

  return (
    <Box className={classes.card}>
      <Box className={classes.head}>
        <Heading className={classes.title}>Assignments chart</Heading>
        <Box className={classes.headRight}>
          <Menu
            icon="chevron-down"
            items={times}
            itemsWrapperClassName={classes.menuLabel}
            className={classes.menu}
          >
            <Text className={classes.menuLabel} level={textLevel.S}>
              {selectedTime.label}
            </Text>
          </Menu>
          {/* <Menu
            icon="chevron-down"
            items={statuses}
            itemsWrapperClassName={classes.menuLabel}
            className={classes.menu}
          >
            <Text className={classes.menuLabel} level={textLevel.S}>
              {selectedStatus.label}
            </Text>
          </Menu> */}
        </Box>
      </Box>
      {isLoading ? (
        <div className={classes.loader}>
          <Icons className="rotate linear infinite" glyph="in-progress" color={colors.primary} />
        </div>
      ) : hasAssignments() && hasDataInRange() ? (
        <Box className={classes.chart}>
          <ApexChart
            options={chartOptions(chartDates, 'Assignments')}
            series={[{ data: chartSeriess }]}
            type="line"
            height={330}
          />
          <Box className={classes.chartLegend}>
            <Box className={classes.circle} />
            <Text className={classes.legendText}>With any Value for Profile Element</Text>
          </Box>
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" paddingY="90px">
          <Text weight={fontWeight.SEMI_BOLD} level={textLevel.S}>
            {!hasAssignments() ? 'No Record Found' : 'No Record Found In This Range'}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export { AssignmentsChartCard };
